export default __webpack_public_path__ + "static/media/14.85daaa18.png";